import { Toaster as Sonner } from "sonner";
import { useDarkMode } from "../../contexts/darkModeProvider";

const Toaster = ({ ...props }) => {
  const { isDarkMode } = useDarkMode();
  const theme = isDarkMode ? "dark" : "light";

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="bottom-left"
      richColors
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-950 group-[.toaster]:border group-[.toaster]:border-gray-200 group-[.toaster]:shadow-xl group-[.toaster]:rounded-lg dark:group-[.toaster]:bg-slate-950 dark:group-[.toaster]:text-gray-50 dark:group-[.toaster]:border-slate-700",
          description:
            "group-[.toast]:text-gray-600 dark:group-[.toast]:text-gray-400",
          actionButton:
            "group-[.toast]:bg-blue-500 group-[.toast]:text-white hover:group-[.toast]:bg-blue-600 dark:group-[.toast]:bg-blue-600 dark:group-[.toast]:hover:bg-blue-700",
          cancelButton:
            "group-[.toast]:bg-gray-200 group-[.toast]:text-gray-900 hover:group-[.toast]:bg-gray-300 dark:group-[.toast]:bg-slate-800 dark:group-[.toast]:text-gray-100 dark:group-[.toast]:hover:bg-slate-700",
          success:
            "group-[.toaster]:bg-green-50 group-[.toaster]:text-green-900 group-[.toaster]:border-green-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-green-950 dark:group-[.toaster]:text-green-50 dark:group-[.toaster]:border-green-800",
          error:
            "group-[.toaster]:bg-red-50 group-[.toaster]:text-red-900 group-[.toaster]:border-red-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-red-950 dark:group-[.toaster]:text-red-50 dark:group-[.toaster]:border-red-800",
          warning:
            "group-[.toaster]:bg-amber-50 group-[.toaster]:text-amber-900 group-[.toaster]:border-amber-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-amber-950 dark:group-[.toaster]:text-amber-50 dark:group-[.toaster]:border-amber-800",
          info: "group-[.toaster]:bg-blue-50 group-[.toaster]:text-blue-900 group-[.toaster]:border-blue-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-blue-950 dark:group-[.toaster]:text-blue-50 dark:group-[.toaster]:border-blue-800",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
